export const DASHBOARD_TEMPLATE = `
<div class="flex min-h-screen overflow-hidden">
<!-- Sidebar -->
<aside class="fixed left-0 top-0 h-full w-64 bg-white border-r border-slate-200 flex flex-col z-50">
<div class="p-6 flex items-center gap-3">
<div class="bg-primary size-10 rounded-lg flex items-center justify-center text-white">
<span class="material-symbols-outlined">motorcycle</span>
</div>
<div>
<h1 class="text-slate-900 text-base font-bold leading-none">MotoJourney</h1>
<p class="text-slate-500 text-[10px] uppercase tracking-wider mt-1 font-semibold">Admin Console</p>
</div>
</div>
<nav class="flex-1 px-4 py-2 space-y-1 overflow-y-auto">
<a class="flex items-center gap-3 px-3 py-2.5 rounded-lg bg-primary text-white shadow-sm shadow-primary/30" href="/dashboard">
<span class="material-symbols-outlined text-[22px]">dashboard</span>
<span class="text-sm font-medium">Dashboard</span>
</a>
<a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/dashboard">
<span class="material-symbols-outlined text-[22px]">verified_user</span>
<span class="text-sm font-medium">Moderation</span>
</a>
<a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/locations">
<span class="material-symbols-outlined text-[22px]">location_on</span>
<span class="text-sm font-medium">Locations</span>
</a>
<a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/events">
<span class="material-symbols-outlined text-[22px]">calendar_today</span>
<span class="text-sm font-medium">Events</span>
</a>
<a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/routes">
<span class="material-symbols-outlined text-[22px]">route</span>
<span class="text-sm font-medium">Routes</span>
</a>
<a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/news">
<span class="material-symbols-outlined text-[22px]">newspaper</span>
<span class="text-sm font-medium">News</span>
</a>
<a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/dashboard">
<span class="material-symbols-outlined text-[22px]">notifications</span>
<span class="text-sm font-medium">Notifications</span>
</a>
<a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/locations/ai-create">
<span class="material-symbols-outlined text-[22px]">auto_awesome</span>
<span class="text-sm font-medium">AI Assistant</span>
</a>
<div class="pt-4 pb-2 px-3">
<p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Management</p>
</div>
<a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/dictionaries">
<span class="material-symbols-outlined text-[22px]">book</span>
<span class="text-sm font-medium">Dictionaries</span>
</a>
<a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/users">
<span class="material-symbols-outlined text-[22px]">group</span>
<span class="text-sm font-medium">Users</span>
</a>
<a class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors" href="/dashboard">
<span class="material-symbols-outlined text-[22px]">settings</span>
<span class="text-sm font-medium">Settings</span>
</a>
</nav>
<div class="p-4 border-t border-slate-200">
<div class="flex items-center gap-3 p-2 rounded-xl bg-slate-50 border border-slate-200">
<div class="size-10 rounded-full bg-cover bg-center ring-2 ring-white" data-alt="Admin user profile picture" style="background-image: url('https://lh3.googleusercontent.com/aida-public/AB6AXuAWTRTAe4si6PMxwy65ZvPKamKiMWtUU9yTTfA_khYkUL-d3loJ8iA6cPJI-_plz2N9ihiRdv6UPwUBctohyLz-QsFl5XIObiQMHImcepI3fK70xILZAxvma55l3VD_V_dppP05oNncOnj5nXsiuaCiC6i3l_BmKbYZAH1X2iRPHNg4rTGhuFfKgmJjAvkToJf1lMPeh2VqHFq5cSfHfMf6MuBbELiJGVCQ42IIul0fPg9PXz1V7Ig7OTEgbX9ArjDz-wxMCOZDaylm')"></div>
<div class="flex flex-col min-w-0">
<p class="text-sm font-semibold text-slate-900 truncate">Alex Rivera</p>
<p class="text-xs text-slate-500 truncate">Senior Admin</p>
</div>
</div>
</div>
</aside>
<!-- Main Content -->
<main class="ml-64 flex-1 overflow-y-auto h-screen bg-background-light">
<!-- Top Bar -->
<header class="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-slate-200 px-8 py-4 flex items-center justify-between">
<div class="flex items-center gap-2">
<h2 class="text-2xl font-bold text-slate-900 tracking-tight">Dashboard</h2>
</div>
<div class="flex items-center gap-3">
<div class="flex items-center gap-2 bg-white border border-slate-200 px-3 py-2 rounded-lg text-sm font-medium text-slate-600 shadow-sm">
<span class="material-symbols-outlined text-lg">calendar_today</span>
<span>Last 14 days</span>
<span class="material-symbols-outlined text-lg">expand_more</span>
</div>
<button class="bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 p-2 rounded-lg shadow-sm transition-all active:scale-95">
<span class="material-symbols-outlined block">refresh</span>
</button>
</div>
</header>
<div class="p-8 space-y-8">
<!-- KPI Cards -->
<section class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
<div class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
<div class="flex justify-between items-start mb-4">
<span class="material-symbols-outlined text-primary bg-primary/10 p-2 rounded-lg">group</span>
<span class="text-emerald-600 text-xs font-bold px-2 py-1 bg-emerald-50 rounded-full">+12%</span>
</div>
<p class="text-slate-500 text-sm font-medium">Total Users</p>
<h3 class="text-2xl font-bold text-slate-900 mt-1 tracking-tight">12,450</h3>
</div>
<div class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
<div class="flex justify-between items-start mb-4">
<span class="material-symbols-outlined text-primary bg-primary/10 p-2 rounded-lg">map</span>
<span class="text-emerald-600 text-xs font-bold px-2 py-1 bg-emerald-50 rounded-full">+5%</span>
</div>
<p class="text-slate-500 text-sm font-medium">Locations</p>
<h3 class="text-2xl font-bold text-slate-900 mt-1 tracking-tight">842</h3>
</div>
<div class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
<div class="flex justify-between items-start mb-4">
<span class="material-symbols-outlined text-primary bg-primary/10 p-2 rounded-lg">route</span>
<span class="text-emerald-600 text-xs font-bold px-2 py-1 bg-emerald-50 rounded-full">+8%</span>
</div>
<p class="text-slate-500 text-sm font-medium">Routes</p>
<h3 class="text-2xl font-bold text-slate-900 mt-1 tracking-tight">1,205</h3>
</div>
<div class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
<div class="flex justify-between items-start mb-4">
<span class="material-symbols-outlined text-primary bg-primary/10 p-2 rounded-lg">article</span>
<span class="text-rose-600 text-xs font-bold px-2 py-1 bg-rose-50 rounded-full">-2%</span>
</div>
<p class="text-slate-500 text-sm font-medium">Articles</p>
<h3 class="text-2xl font-bold text-slate-900 mt-1 tracking-tight">328</h3>
</div>
<div class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
<div class="flex justify-between items-start mb-4">
<span class="material-symbols-outlined text-primary bg-primary/10 p-2 rounded-lg">notifications_active</span>
<span class="text-emerald-600 text-xs font-bold px-2 py-1 bg-emerald-50 rounded-full">+15%</span>
</div>
<p class="text-slate-500 text-sm font-medium">Alerts Sent</p>
<h3 class="text-2xl font-bold text-slate-900 mt-1 tracking-tight">2,840</h3>
</div>
</section>
<!-- Moderation Section -->
<section class="space-y-4">
<div class="flex items-center justify-between">
<h3 class="text-lg font-bold text-slate-900">Moderation Queue</h3>
<div class="flex gap-4">
<div class="flex items-center gap-2">
<span class="size-2 rounded-full bg-amber-400"></span>
<span class="text-xs font-semibold text-slate-600">Pending: 198 items</span>
</div>
</div>
</div>
<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
<div class="bg-amber-50 border border-amber-100 p-4 rounded-xl">
<p class="text-amber-800 text-xs font-bold uppercase tracking-wider mb-1">Locations</p>
<div class="flex items-baseline gap-2">
<span class="text-2xl font-bold text-amber-900">14</span>
<span class="text-xs text-amber-700 font-medium">awaiting review</span>
</div>
</div>
<div class="bg-indigo-50 border border-indigo-100 p-4 rounded-xl">
<p class="text-indigo-800 text-xs font-bold uppercase tracking-wider mb-1">Routes</p>
<div class="flex items-baseline gap-2">
<span class="text-2xl font-bold text-indigo-900">28</span>
<span class="text-xs text-indigo-700 font-medium">awaiting review</span>
</div>
</div>
<div class="bg-slate-50 border border-slate-200 p-4 rounded-xl">
<p class="text-slate-800 text-xs font-bold uppercase tracking-wider mb-1">Comments</p>
<div class="flex items-baseline gap-2">
<span class="text-2xl font-bold text-slate-900">156</span>
<span class="text-xs text-slate-700 font-medium">awaiting review</span>
</div>
</div>
</div>
<div class="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm">
<table class="w-full text-left border-collapse">
<thead>
<tr class="bg-slate-50 border-b border-slate-200">
<th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Type</th>
<th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Title</th>
<th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Author</th>
<th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Date</th>
<th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Status</th>
<th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider text-right">Actions</th>
</tr>
</thead>
<tbody class="divide-y divide-slate-100">
<tr class="hover:bg-slate-50/50 transition-colors">
<td class="px-6 py-4"><span class="px-2 py-1 rounded bg-indigo-50 text-indigo-700 text-[10px] font-bold uppercase">Location</span></td>
<td class="px-6 py-4 text-sm font-semibold text-slate-900">Alpine Pass Overlook</td>
<td class="px-6 py-4 text-sm text-slate-600">Marc V.</td>
<td class="px-6 py-4 text-sm text-slate-500">Oct 24, 2023</td>
<td class="px-6 py-4">
<span class="flex items-center gap-1.5 text-amber-600 font-medium text-xs">
<span class="size-1.5 rounded-full bg-amber-500"></span> Pending
                                        </span>
</td>
<td class="px-6 py-4 text-right space-x-2">
<button class="p-1.5 hover:bg-slate-100 rounded text-slate-400 hover:text-primary transition-colors">
<span class="material-symbols-outlined text-[20px]">visibility</span>
</button>
<button class="p-1.5 hover:bg-emerald-50 rounded text-slate-400 hover:text-emerald-600 transition-colors">
<span class="material-symbols-outlined text-[20px]">check_circle</span>
</button>
<button class="p-1.5 hover:bg-rose-50 rounded text-slate-400 hover:text-rose-600 transition-colors">
<span class="material-symbols-outlined text-[20px]">cancel</span>
</button>
</td>
</tr>
<tr class="hover:bg-slate-50/50 transition-colors">
<td class="px-6 py-4"><span class="px-2 py-1 rounded bg-blue-50 text-blue-700 text-[10px] font-bold uppercase">Route</span></td>
<td class="px-6 py-4 text-sm font-semibold text-slate-900">Coastal Cliff Run</td>
<td class="px-6 py-4 text-sm text-slate-600">Sarah Jones</td>
<td class="px-6 py-4 text-sm text-slate-500">Oct 23, 2023</td>
<td class="px-6 py-4">
<span class="flex items-center gap-1.5 text-amber-600 font-medium text-xs">
<span class="size-1.5 rounded-full bg-amber-500"></span> Pending
                                        </span>
</td>
<td class="px-6 py-4 text-right space-x-2">
<button class="p-1.5 hover:bg-slate-100 rounded text-slate-400 hover:text-primary transition-colors">
<span class="material-symbols-outlined text-[20px]">visibility</span>
</button>
<button class="p-1.5 hover:bg-emerald-50 rounded text-slate-400 hover:text-emerald-600 transition-colors">
<span class="material-symbols-outlined text-[20px]">check_circle</span>
</button>
<button class="p-1.5 hover:bg-rose-50 rounded text-slate-400 hover:text-rose-600 transition-colors">
<span class="material-symbols-outlined text-[20px]">cancel</span>
</button>
</td>
</tr>
<tr class="hover:bg-slate-50/50 transition-colors">
<td class="px-6 py-4"><span class="px-2 py-1 rounded bg-slate-100 text-slate-700 text-[10px] font-bold uppercase">Comment</span></td>
<td class="px-6 py-4 text-sm font-semibold text-slate-900">"Great spot for a break..."</td>
<td class="px-6 py-4 text-sm text-slate-600">Rider_99</td>
<td class="px-6 py-4 text-sm text-slate-500">Oct 23, 2023</td>
<td class="px-6 py-4">
<span class="flex items-center gap-1.5 text-amber-600 font-medium text-xs">
<span class="size-1.5 rounded-full bg-amber-500"></span> Pending
                                        </span>
</td>
<td class="px-6 py-4 text-right space-x-2">
<button class="p-1.5 hover:bg-slate-100 rounded text-slate-400 hover:text-primary transition-colors">
<span class="material-symbols-outlined text-[20px]">visibility</span>
</button>
<button class="p-1.5 hover:bg-emerald-50 rounded text-slate-400 hover:text-emerald-600 transition-colors">
<span class="material-symbols-outlined text-[20px]">check_circle</span>
</button>
<button class="p-1.5 hover:bg-rose-50 rounded text-slate-400 hover:text-rose-600 transition-colors">
<span class="material-symbols-outlined text-[20px]">cancel</span>
</button>
</td>
</tr>
</tbody>
</table>
<div class="p-4 bg-slate-50 text-center">
<button class="text-sm font-semibold text-primary hover:underline">View All Pending Items</button>
</div>
</div>
</section>
<!-- Activity Chart Section -->
<section class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
<div class="flex items-center justify-between mb-8">
<div>
<h3 class="text-lg font-bold text-slate-900">Activity Over Time</h3>
<p class="text-xs text-slate-500 font-medium">Trends for core growth metrics</p>
</div>
<div class="flex gap-4">
<div class="flex items-center gap-1.5">
<span class="size-2 rounded-full bg-primary"></span>
<span class="text-xs text-slate-600 font-medium">Users</span>
</div>
<div class="flex items-center gap-1.5">
<span class="size-2 rounded-full bg-emerald-500"></span>
<span class="text-xs text-slate-600 font-medium">Locations</span>
</div>
<div class="flex items-center gap-1.5">
<span class="size-2 rounded-full bg-slate-400"></span>
<span class="text-xs text-slate-600 font-medium">News</span>
</div>
</div>
</div>
<!-- Placeholder for Chart -->
<div class="relative h-[240px] w-full flex items-end gap-1 px-2 border-b border-l border-slate-100">
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[40%]"></div>
<div class="w-full bg-primary rounded-t h-[30%] -mt-10"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[50%]"></div>
<div class="w-full bg-primary rounded-t h-[45%]"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[35%]"></div>
<div class="w-full bg-primary rounded-t h-[25%]"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[65%]"></div>
<div class="w-full bg-primary rounded-t h-[55%]"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[45%]"></div>
<div class="w-full bg-primary rounded-t h-[40%]"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[80%]"></div>
<div class="w-full bg-primary rounded-t h-[70%]"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[55%]"></div>
<div class="w-full bg-primary rounded-t h-[45%]"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[75%]"></div>
<div class="w-full bg-primary rounded-t h-[65%]"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[90%]"></div>
<div class="w-full bg-primary rounded-t h-[80%]"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[60%]"></div>
<div class="w-full bg-primary rounded-t h-[50%]"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[70%]"></div>
<div class="w-full bg-primary rounded-t h-[60%]"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[85%]"></div>
<div class="w-full bg-primary rounded-t h-[75%]"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[65%]"></div>
<div class="w-full bg-primary rounded-t h-[55%]"></div>
</div>
<div class="flex-1 flex flex-col justify-end gap-1 h-full">
<div class="w-full bg-primary/20 rounded-t h-[95%]"></div>
<div class="w-full bg-primary rounded-t h-[85%]"></div>
</div>
</div>
<div class="flex justify-between mt-4 px-2 text-[10px] font-bold text-slate-400 uppercase tracking-widest">
<span>14 Days Ago</span>
<span>Today</span>
</div>
</section>
<!-- Top Locations & News -->
<section class="grid grid-cols-1 lg:grid-cols-2 gap-8">
<div class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
<div class="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
<h3 class="text-base font-bold text-slate-900">Top Locations</h3>
<button class="text-xs font-bold text-primary">View More</button>
</div>
<div class="p-6 space-y-4">
<div class="flex items-center gap-4">
<div class="size-12 rounded-lg bg-cover bg-center" data-alt="Mountain pass landscape thumbnail" style="background-image: url('https://lh3.googleusercontent.com/aida-public/AB6AXuAqt4BQZP5FYYvyitprfTcJuvEtT2FK1EdXeQ8BsD2hs9-9fqgpgkKvyJbcaYeb8jYmzy-2iCroKxo2Lmlp35kR-6uWL0jLb0HGluanMW5Xx1a9ZN0FwPH_dy0hHtqr4UBL0DjSNi02LNWG2FDdMT3fYqkv_HYerKCoPImon7MOLl3jEHLEDi6YEFJvjsuzKpi4pnYkupZYd4erFGooDli1w4HNFP67OP8rfP2y5PB5EF6tU6N1wFW6bFFzwCn0WUBHbQx_FlN_MbuX')"></div>
<div class="flex-1">
<p class="text-sm font-bold text-slate-900">Stelvio Pass, Italy</p>
<p class="text-xs text-slate-500">4,231 Visits this month</p>
</div>
<div class="text-right">
<span class="text-emerald-600 font-bold text-sm">#1</span>
</div>
</div>
<div class="flex items-center gap-4">
<div class="size-12 rounded-lg bg-cover bg-center" data-alt="Coastal road landscape thumbnail" style="background-image: url('https://lh3.googleusercontent.com/aida-public/AB6AXuCPmGF397O8BnfpcaheDOhV3dcwTkehSwInLQAcl1MQ9OpmJqou9-11CrpfmncAi8qsO8954gY_JeXThHV3p_f9aRuClxAClwD5zJFt9QDJs2vtq6AV6BRI8W6nuQB1o6jqwcGcHvFa7o-jMmV538azt4NX-DPwOZ0N5y6s1NgHH5s7p42g2T7AGNsXXEEfKKIuSDn2ay1k5LKqKogLJ7rxIAjzbETIFmjPSLPjBTmzXq1pfrM-II-oUotayxiMvN7IOQlh69pqEzOL')"></div>
<div class="flex-1">
<p class="text-sm font-bold text-slate-900">Pacific Coast Highway, USA</p>
<p class="text-xs text-slate-500">3,892 Visits this month</p>
</div>
<div class="text-right">
<span class="text-emerald-600 font-bold text-sm">#2</span>
</div>
</div>
<div class="flex items-center gap-4">
<div class="size-12 rounded-lg bg-cover bg-center" data-alt="Forest road landscape thumbnail" style="background-image: url('https://lh3.googleusercontent.com/aida-public/AB6AXuC3m2QrWEbwJ8maGsDWg3JLoqYJLQ7rClot-LvhCoFVRCbNXRMYdwuUD09X-T3pCkaHjPOyzTESmRfAO4gNueOX1uBOpx0KpKksmsgNYYW0YOCZo8gRE-jYYP8h_HSp4yrDDV4S9C8xITdnSzahg2UPgmLPnJ7nNhpz0vokT17jrfcgQJnur7Q4GRBZNGMyuHggxIWHqfJZqx7F4afFU7R8RLq8HoASI6X8Dfae1X2k2gQBraBZZNDpjar_w-uUxq0cJgCh6DGYqG_i')"></div>
<div class="flex-1">
<p class="text-sm font-bold text-slate-900">Black Forest High Road, GER</p>
<p class="text-xs text-slate-500">3,120 Visits this month</p>
</div>
<div class="text-right">
<span class="text-emerald-600 font-bold text-sm">#3</span>
</div>
</div>
</div>
</div>
<div class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
<div class="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
<h3 class="text-base font-bold text-slate-900">Top News Articles</h3>
<button class="text-xs font-bold text-primary">View More</button>
</div>
<div class="p-6 space-y-4">
<div class="flex items-center gap-4">
<div class="size-12 rounded-lg bg-slate-100 flex items-center justify-center text-slate-400">
<span class="material-symbols-outlined">trending_up</span>
</div>
<div class="flex-1 min-w-0">
<p class="text-sm font-bold text-slate-900 truncate">Best 2024 Touring Bikes</p>
<p class="text-xs text-slate-500">12.5k Reads • 48 Comments</p>
</div>
<button class="text-slate-400 hover:text-slate-900">
<span class="material-symbols-outlined text-sm">open_in_new</span>
</button>
</div>
<div class="flex items-center gap-4">
<div class="size-12 rounded-lg bg-slate-100 flex items-center justify-center text-slate-400">
<span class="material-symbols-outlined">shield</span>
</div>
<div class="flex-1 min-w-0">
<p class="text-sm font-bold text-slate-900 truncate">Winter Maintenance Guide</p>
<p class="text-xs text-slate-500">8.2k Reads • 31 Comments</p>
</div>
<button class="text-slate-400 hover:text-slate-900">
<span class="material-symbols-outlined text-sm">open_in_new</span>
</button>
</div>
<div class="flex items-center gap-4">
<div class="size-12 rounded-lg bg-slate-100 flex items-center justify-center text-slate-400">
<span class="material-symbols-outlined">explore</span>
</div>
<div class="flex-1 min-w-0">
<p class="text-sm font-bold text-slate-900 truncate">Secret Rides: Atlas Mountains</p>
<p class="text-xs text-slate-500">6.7k Reads • 22 Comments</p>
</div>
<button class="text-slate-400 hover:text-slate-900">
<span class="material-symbols-outlined text-sm">open_in_new</span>
</button>
</div>
</div>
</div>
</section>
<!-- Notifications & Activity Section -->
<section class="grid grid-cols-1 lg:grid-cols-3 gap-8">
<!-- Delivery Stats -->
<div class="lg:col-span-2 bg-white rounded-xl border border-slate-200 shadow-sm p-6">
<h3 class="text-base font-bold text-slate-900 mb-6">Notifications Delivery Status</h3>
<div class="grid grid-cols-1 md:grid-cols-2 gap-8">
<div class="space-y-4">
<p class="text-xs font-bold text-slate-400 uppercase tracking-widest">Delivery Performance</p>
<div class="space-y-3">
<div>
<div class="flex justify-between text-xs mb-1">
<span class="font-medium text-slate-600">Successfully Sent</span>
<span class="font-bold text-emerald-600">98.2%</span>
</div>
<div class="w-full bg-slate-100 h-2 rounded-full overflow-hidden">
<div class="bg-emerald-500 h-full w-[98.2%]"></div>
</div>
</div>
<div>
<div class="flex justify-between text-xs mb-1">
<span class="font-medium text-slate-600">Pending</span>
<span class="font-bold text-amber-600">1.5%</span>
</div>
<div class="w-full bg-slate-100 h-2 rounded-full overflow-hidden">
<div class="bg-amber-400 h-full w-[1.5%]"></div>
</div>
</div>
<div>
<div class="flex justify-between text-xs mb-1">
<span class="font-medium text-slate-600">Failed</span>
<span class="font-bold text-rose-600">0.3%</span>
</div>
<div class="w-full bg-slate-100 h-2 rounded-full overflow-hidden">
<div class="bg-rose-500 h-full w-[0.3%]"></div>
</div>
</div>
</div>
</div>
<div class="space-y-4">
<p class="text-xs font-bold text-slate-400 uppercase tracking-widest">Channel Distribution</p>
<div class="space-y-3">
<div class="flex items-center justify-between p-2 rounded-lg bg-slate-50">
<div class="flex items-center gap-2">
<span class="material-symbols-outlined text-slate-400 text-lg">mail</span>
<span class="text-sm font-medium text-slate-700">Email</span>
</div>
<span class="text-sm font-bold text-slate-900">1,420</span>
</div>
<div class="flex items-center justify-between p-2 rounded-lg bg-slate-50">
<div class="flex items-center gap-2">
<span class="material-symbols-outlined text-slate-400 text-lg">phone_android</span>
<span class="text-sm font-medium text-slate-700">Push Notification</span>
</div>
<span class="text-sm font-bold text-slate-900">985</span>
</div>
<div class="flex items-center justify-between p-2 rounded-lg bg-slate-50">
<div class="flex items-center gap-2">
<span class="material-symbols-outlined text-slate-400 text-lg">chat_bubble</span>
<span class="text-sm font-medium text-slate-700">In-App Message</span>
</div>
<span class="text-sm font-bold text-slate-900">435</span>
</div>
</div>
</div>
</div>
</div>
<!-- Recent Activity -->
<div class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden flex flex-col">
<div class="px-6 py-4 border-b border-slate-100">
<h3 class="text-base font-bold text-slate-900">Recent Activity</h3>
</div>
<div class="flex-1 p-6 space-y-6 overflow-y-auto max-h-[300px]">
<div class="flex gap-3 relative before:absolute before:left-[17px] before:top-[34px] before:bottom-[-24px] before:w-px before:bg-slate-200 last:before:hidden">
<div class="size-9 rounded-full bg-primary/10 flex items-center justify-center text-primary z-10 bg-white border border-primary/20 shrink-0">
<span class="material-symbols-outlined text-lg">check</span>
</div>
<div class="flex-1">
<p class="text-sm text-slate-800"><span class="font-bold">Admin Sam</span> approved a new location</p>
<p class="text-xs text-slate-400 mt-1">2 mins ago</p>
</div>
</div>
<div class="flex gap-3 relative before:absolute before:left-[17px] before:top-[34px] before:bottom-[-24px] before:w-px before:bg-slate-200 last:before:hidden">
<div class="size-9 rounded-full bg-rose-100 flex items-center justify-center text-rose-600 z-10 bg-white border border-rose-200 shrink-0">
<span class="material-symbols-outlined text-lg">block</span>
</div>
<div class="flex-1">
<p class="text-sm text-slate-800"><span class="font-bold">System</span> blocked a suspicious login</p>
<p class="text-xs text-slate-400 mt-1">15 mins ago</p>
</div>
</div>
<div class="flex gap-3 relative before:absolute before:left-[17px] before:top-[34px] before:bottom-[-24px] before:w-px before:bg-slate-200 last:before:hidden">
<div class="size-9 rounded-full bg-slate-100 flex items-center justify-center text-slate-600 z-10 bg-white border border-slate-200 shrink-0">
<span class="material-symbols-outlined text-lg">person_add</span>
</div>
<div class="flex-1">
<p class="text-sm text-slate-800"><span class="font-bold">New User</span> joined the community</p>
<p class="text-xs text-slate-400 mt-1">1 hour ago</p>
</div>
</div>
<div class="flex gap-3 relative before:absolute before:left-[17px] before:top-[34px] before:bottom-[-24px] before:w-px before:bg-slate-200 last:before:hidden">
<div class="size-9 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 z-10 bg-white border border-blue-200 shrink-0">
<span class="material-symbols-outlined text-lg">edit</span>
</div>
<div class="flex-1">
<p class="text-sm text-slate-800"><span class="font-bold">Sarah J.</span> updated a route</p>
<p class="text-xs text-slate-400 mt-1">3 hours ago</p>
</div>
</div>
</div>
</div>
</section>
</div>
</main>
</div>
`;
